import { useQuery } from 'react-query';
import { getChainDescriptions } from '../index';
export const useGetChainDescriptions = () => 
// Префикс ключа общий со страницей цепочек - создание/удаление цепочки обновит и этот список.
useQuery(['GetIntegrationChainDescriptionList', 'all'], getChainDescriptions, {
    // Справочник цепочек редко меняется - не перезапрашиваем при каждом открытии формы.
    staleTime: 5 * 60 * 1000,
});
